import { EnumFilter } from "@/components/data-table/components/EnumFilter";
import StandardQueryTable from "@/components/StandardQueryTable";
import { Module, PATH_STORE } from "@/constants";
import i18n from "@/i18n";
import { readStore } from "@/schemas/store";
import { STORE_STATUS } from "@/schemas/storeStatus";
import { ReadStore } from "@/types/store";
import { Row } from "@tanstack/react-table";
import { generatePath } from "react-router-dom";
import { StoreService } from "../service/store";

const StoreList = () => (
  <StandardQueryTable
    schema={readStore}
    name={Module.Stores}
    fetchList={StoreService.getList}
    pathBuilder={(store) => generatePath(PATH_STORE, { storeId: store.id })}
    tableFeatures={{
      exportSettings: { moduleName: Module.Stores },
    }}
    columnOverrides={{
      status: {
        id: "status",
        cell: ({ row }: { row: Row<ReadStore> }) =>
          i18n.t(`storeStatuses.${row.original.status}`),
        meta: {
          filter: {
            component: EnumFilter,
            props: {
              options: STORE_STATUS,
              translationKey: "storeStatuses",
            },
          },
        },
      },
    }}
  />
);

export default StoreList;
